import Modal from "global/component/Genericos/Modal/Modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import {
  BtnBuscarTurnos,
  BtnContainer,
  BuscadorBox,
  ButtonContainer,
  ContainerNecesitoTurno,
  TextNecesitoTurno,
} from "./localStyle";
import camelize from "global/utils/camelize";
import { useHistory } from "react-router";
import { estudiosMasSolicitadosPorPaciente } from "_+_Portal/context/Actions/estudioGrupo/estudioGrupo";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import BuscadorConsultaMedica from "_+_Portal/components/Turnos/BuscadorConsultaMedica/BuscadorConsultaMedica";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { motion } from "framer-motion";
import { getLocalStorage } from "global/utils/safeJsonParse";

const MasSolicitadosConsultas = () => {
  // -------------------------  context ----------------------------
  const { modalState, authState } = useContext(GlobalContext);
  const { selectDropDownState, estudioGrupoDispatch, estudioGrupoState } =
    useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  const [listaConsultas, setListaConsultas] = useState(false);
  const [itemBusqueda, setItemBusqueda] = useState(null);
  const [loading, setLoading] = useState(false);
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState?.auth?.data?.paciente?.nombre;
  let idTerminal = getLocalStorage("idTerminal");
  const history = useHistory();

  // -------------------------  constantes ---------------------------

  // -------------------------  funciones ----------------------------
  const handleOnclick = (path, item) => {
    setLoading(true);
    if (path === "CONSULTA") {
      setItemBusqueda(item);
      setLoading(false);
    } else if (path === "OTROS") {
      if (idTerminal) {
        history.push("/buscadorCheckin");
      } else {
        history.push("/consultamedica");
      }
    }
  };
  // -------------------------  funciones ----------------------------

  // -------------------------  useEffects ----------------------------
  useEffect(() => {
    if (!selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      estudiosMasSolicitadosPorPaciente()(estudioGrupoDispatch);
    } else {
      estudiosMasSolicitadosPorPaciente(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
      )(estudioGrupoDispatch);
    }
  }, []);

  useEffect(() => {
    if (
      estudioGrupoState.estudiosMasBuscado.data !== null &&
      estudioGrupoState.estudiosMasBuscado.data !== undefined
    ) {
      let filtroConsulta = estudioGrupoState.estudiosMasBuscado.data.filter(
        (item) =>
          item.idCircuito !== "RMN" &&
          item.idCircuito !== "TOMO" &&
          item.sonPracticas === false,
      );
      // Separo grupoMed de agendas
      const grupoMed = filtroConsulta.filter((item) => item.id > 0);
      const agenda = filtroConsulta.filter((item) => item.id < 0);
      // Concateno las agendas al final de gruposMed
      const turnosCompletos = grupoMed.concat(agenda);
      // Ordeno de mas buscados a menos
      turnosCompletos.sort((a, b) => {
        return b.cantBusquedas - a.cantBusquedas;
      });
      setListaConsultas(turnosCompletos);
    }
  }, [estudioGrupoState.estudiosMasBuscado.data]);
  // -------------------------  useEffects ----------------------------

  return (
    <>
      {modalState.modal.show && <Modal />}
      <Loading
        dataLoading={estudioGrupoState.estudiosMasBuscado.loading || loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      <LayoutPasos
        title={"Necesito turno"}
        subtitle={camelize("Para: " + pacienteNombre)}
      >
        <ContainerNecesitoTurno
          initial="hidden"
          animate="show"
          variants={containerVariants}
          key={listaConsultas?.length}
        >
          <TextNecesitoTurno
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 1.5,
              ease: "easeInOut",
              opacity: [0, 0.3, 0.7, 1],
              times: [0, 0.3, 0.7, 1],
            }}
            $isTerminal={idTerminal}
          >
            <span className="title-saludo">
              <span className="title-negrita">
                Estos son tus turnos de consulta más solicitados
              </span>
            </span>
          </TextNecesitoTurno>
          <BtnContainer>
            {listaConsultas &&
              listaConsultas.map((item, index) => {
                return (
                  <motion.div variants={itemVariants}>
                    <BtnLink
                      key={index}
                      // Icon={<TildeOk color={"var(--color-primary)"} />}
                      type={"NORMAL"}
                      title={camelize(item.descripcion)}
                      onclick={() => handleOnclick("CONSULTA", item)}
                      textCentre={true}
                      normalFont={true}
                    />
                  </motion.div>
                );
              })}
          </BtnContainer>
          <ButtonContainer
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BtnBuscarTurnos
              className={"bgc-primary c-white"}
              onClick={() => handleOnclick("OTROS")}
            >
              Buscar otros turnos
            </BtnBuscarTurnos>
          </ButtonContainer>
          <BuscadorBox>
            <BuscadorConsultaMedica
              onChangeMultitabMobile={() => {}}
              buscadorTurnos={true}
              itemBusqueda={itemBusqueda}
              busquedaAuto={true}
              setLoadingQR={setLoading}
            />
          </BuscadorBox>
        </ContainerNecesitoTurno>
      </LayoutPasos>
    </>
  );
};

export default MasSolicitadosConsultas;
